export class BackgroundStyleFormatHelper {
    static _targetTexts = {
        "component": "Elemento",
        "description": "Descrição",
        "tableheader": "Cabeçalho da Tabela",
        "rows": "Zebras Alternadas",
        "hourlabel": "Horas (legenda)",
        "minutelabel": "Minutos (legenda)",
        "hour": "Horas",
        "minute": "Minutos",
        "stopsbar": "Faixa da Paragem",
        "zonesbar": "Zonas",
        "durationbar": "Duração",
        "smscode": "Código SMS",
        "stopcode": "Código da Paragem",
        "stopname": "Nome da Paragem",
        "linecode": "Código da Linha",
        "linename": "Nome da Linha",
        "spine": "Espinha",
        "trips": "Viagens",
        "triptime": "Tempo de Passgem",
        "header": "Cabeçalho",
        "tripsplitter": "Separador entre Viagens",
        "linepreviousstops": "Linha das Paragens Anteriores",
        "linenextstops": "Linha das Próximas Paragens",
        "stopsinterfacesbackground":"Nome das Paragens e Interfaces",
        "currentstop": "Paragem Atual",
        "hourcontinuousbackground": "Fundo Contínuo das Horas",
        "passingindicator": "Indicador de Primeira/Última Viagem",
        "exceptionlabel": "Legenda da Exceção",
        "exceptionindicator": "Indicação de Exceção",
        "pathdescription": "Descrição do Percurso",
        "componentname": "Nome do Componente",
        "maindaytype": "Tipo de Dia Principal",
        "mainplannings": "Planeamentos Principais",
        "secondarydaytypes": "Tipos de Dia Secundários",
        "firstandlasttrip": "Primeira e Última Viagem",
        "firstandlasttripvalues": "Horas da Primeira e Última Viagem",
        "intervalsnames": "Nomes dos Intervalos de Tempo",
        "intervalsvalues": "Valores dos Intervalos de Tempo",
        "stopsline": "Linha entre Paragens",
        "pointname": "Nome do Ponto",
        "divider": "Divisor",
        "secundarylinecode": "Linhas não presentes no mapa"
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}
